import { useEffect, useRef } from 'react';
import useIsomorphicLayoutEffect from "@hooks/useIsomorphicLayoutEffect";
function useTimeout(callback, delay) {
  var savedCallback = useRef(callback);

  // Remember the latest callback if it changes.
  useIsomorphicLayoutEffect(function () {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the timeout.
  useEffect(function () {
    // Don't schedule if no delay is specified.
    // Note: 0 is a valid value for delay.
    if (!delay && delay !== 0) {
      return;
    }
    var id = setTimeout(function () {
      savedCallback.current();
    }, delay);
    return function () {
      clearTimeout(id);
    };
  }, [delay]);
}
export default useTimeout;